import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  makeStyles,
  DialogTitle,
  MenuItem,
  TextField,
  TableCell,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import EditIcon from "@material-ui/icons/Edit";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import ReplyIcon from "@material-ui/icons/Reply";

import {
  dateFormated,
  presentFormatedData,
} from "../../functionalComponents/dataFormatFunctions";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { ChevronRight } from "@material-ui/icons";
import PONegotiationDialogBox from "./PONegotiationDialogBox";
import { useDispatch } from "react-redux";
import {
  DESTROY_BACKDROP,
  OPEN_BACKDROP,
} from "../../../../containers/actions/types";
import { fetchSLFromPODashboard } from "../../../../containers/actions/common/purchaseOrderAction";
import axios from "axios";
import { appUrl } from "../../../../../../utils/config";
import WarningIcon from "@material-ui/icons/Warning";
import CloseIcon from "@material-ui/icons/Close";
import StyledButton from "../../models/Button";
import CancelIcon from "@material-ui/icons/Cancel";
import BackDropLoading from "../../models/BackDrop";
import CustomDatePickerMui from "../../models/inputs/DateInput";
import jwtDecode from "jwt-decode";

const useStyles = makeStyles((theme) => ({
  responseBtn: {
    cursor: "pointer",
    fontSize: "large",
    // color:"#ec6535",
    //     '&:hover': {
    //         fontSize: 'medium',
    // },
  },
  dialogContent: {
    textAlign: "center",
    padding: "30px 36px 24px 36px",
  },
  avatar: {
    color: "green",
    margin: "0 auto",
    fontSize: "80px",
  },
  dialogActions: {
    justifyContent: "center",
    marginTop: theme.spacing(2),
  },
  dialogPaper: {
    borderRadius: "1rem",
  },
}));

const EditCDMOPOColumns = (props) => {
  const { row, handleRefresh, featuresAccess,showPencilIcon } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const [successDialogBox, setSuccessDialogBox] = useState({
    openDialogBox: false,
    dialogBoxType: "",
  });

  const [saveFailed, setSaveFailed] = useState(false);
  const [negotiation, setNegotiation] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectedReason, setSelectedReason] = useState("");
  const [comment, setComment] = useState("");
  const [error, setError] = useState(false);
  const [reasonCodes, setReasonCodes] = useState([
    // { reasonCode: "none", reasonDescription: "-", reasonCodeID: "none" },
  ]);
  // BCM-791: which value each interaction targets ("qty" | "date")
  const [negotiationValueType, setNegotiationValueType] = useState("qty");
  const [rejectValueType, setRejectValueType] = useState("qty");
  const [actionValueType, setActionValueType] = useState("qty");
  const actionLabel = actionValueType === "date" ? "Date" : "Qty";
  const rejectLabel = rejectValueType === "date" ? "Date" : "Qty";
//console.log("showPencilIcon value is",props.showPencilIcon)
  // BCM-791: open the reject dialog scoped to a single value (Sponsor rejects CMO)
  const handleOpen = (vType) => {
    const v = vType === "date" ? "date" : "qty";
    setRejectValueType(v);
    setActionValueType(v);
    setOpen(true);
  };

  // BCM-791: open the edit popup scoped to a single value (CMO edits its proposal)
  const handleEditOpen = (vType) => {
    setNegotiationValueType(vType === "date" ? "date" : "qty");
    setNegotiation(true);
  };

  // BCM-791: accept a single CMO proposed value (Sponsor action)
  const handleAccept = (vType) => {
    const v = vType === "date" ? "date" : "qty";
    setActionValueType(v);
    if (row?.scheduleLineDetails?.scheduleLineStatusID == 29) {
      handleSave("revisedOfferAccepted", v);
    } else {
      handleSave("AcceptOffer", v);
    }
  };

  // Function to close the dialog
  const handleClose = () => {
    setOpen(false);
    setSelectedReason("");
    setComment("");
    setError(false);
  };

  const handleNegotiation = (type) => {
    setNegotiation(false);
    if (type === "success") {
      setSuccessDialogBox({
        openDialogBox: true,
        dialogBoxType: "valueProposed",
      });
    } else if (type === "failed") {
      setSaveFailed(true);
    }
  };

  const handleSave = (type, actionVType) => {
    dispatch({
      type: OPEN_BACKDROP,
      // backdropText: `Please don't refresh or close the tab while processing`,
    });

    // BCM-791 Approach A: exactly one change flag is set per action (qty XOR date).
    const vType = actionVType === "date" ? "date" : "qty";
    const changeInQty = vType === "qty";
    const changeInDate = vType === "date";
    const isAccept = type === "AcceptOffer" || type === "revisedOfferAccepted";
    const isReject = type === "RejectOffer" || type === "revisedOfferRejected";
    // BCM-791: separate accept/reject flags per value, set based on which action
    // (accept vs reject) and which value (qty vs date) was clicked
    const qtyAcceptedFlag = isAccept && changeInQty;
    const dateAcceptedFlag = isAccept && changeInDate;
    const qtyRejectedFlag = isReject && changeInQty;
    const dateRejectedFlag = isReject && changeInDate;

    let data = {
      vendorMosymphonyID: row?.scheduleLineDetails?.vendorMosymphonyID,
      scheduleAgreementStatusID: row?.scheduleLineDetails?.scheduleLineStatusID,
      scheduleAgreementStatusText:
        row?.scheduleLineDetails?.scheduleLineStatusText,
      schrockenSAID: row?.scheduleLineDetails?.schrockenSAID,
      scheduleAgreementNumber:
        row?.scheduleLineDetails?.scheduleAgreementNumber,
      vendorName: row?.scheduleLineDetails?.vendorName,
      sponsorName: row?.scheduleLineDetails?.sponsorName,
      productsList: row?.scheduleLineDetails
        ? [
            {
              fgMaterialCode: row?.scheduleLineDetails?.fgMaterialCode,
              fgMaterialName: row?.scheduleLineDetails?.fgMaterialName,
            },
          ]
        : [],
      poApprovedFlag: [21, 22, 23].includes(
        row?.scheduleLineDetails?.scheduleLineStatusID
      )
        ? false
        : true,
      poLineEditFlag:
        type === "AcceptOffer" ||
        type === "revisedOfferAccepted" ||
        type === "RejectOffer" ||
        type === "revisedOfferRejected"
          ? true
          : false,
      acceptOfferFlag:
        type === "AcceptOffer" || type === "revisedOfferAccepted"
          ? true
          : false,
      //rejectOfferFlag: false,
      rejectOfferFlag:
        type === "RejectOffer" || type === "revisedOfferRejected"
          ? true
          : false,
      approveFlag: false,
      shareWithCMOFlag: type === "sharedWithCMO" ? true : false,
      confirmedFlag: false,
      SLDetails: {
        ...row?.scheduleLineDetails,

        reasonCode: selectedReason,
        comments: comment,
        // sponsorProposedDeliveryDate:
        //   type === "AcceptOffer" || type === "revisedOfferAccepted"
        //     ? null
        //     : row?.scheduleLineDetails?.sponsorProposedDeliveryDate,
        // sponsorProposedQuantity:
        //   type === "AcceptOffer" || type === "revisedOfferAccepted"
        //     ? null
        //     : row?.scheduleLineDetails?.sponsorProposedQuantity,

        // cmoProposedDeliveryDate:
        //   type === "AcceptOffer" || type === "revisedOfferAccepted"
        //     ? null
        //     : row?.scheduleLineDetails?.cmoProposedDeliveryDate,

        // cmoProposedQuantity:
        //   type === "AcceptOffer" || type === "revisedOfferAccepted"
        //     ? null
        //     : row?.scheduleLineDetails?.cmoProposedQuantity,
        // committedDeliveryDate:
        //   type === "AcceptOffer" || type === "revisedOfferAccepted"
        //     ? row?.scheduleLineDetails?.cmoProposedDeliveryDate
        //     : row?.scheduleLineDetails?.committedDeliveryDate,
        // committedQuantity:
        //   type === "AcceptOffer" || type === "revisedOfferAccepted"
        //     ? row?.scheduleLineDetails?.cmoProposedQuantity
        //     : row?.scheduleLineDetails?.committedQuantity,
        // BCM-791: Sponsor accepts/rejects a single CMO proposed value
        changeInQty: changeInQty,
        changeInDate: changeInDate,
        qtyAcceptedFlag: qtyAcceptedFlag,
        dateAcceptedFlag: dateAcceptedFlag,
        qtyRejectedFlag: qtyRejectedFlag,
        dateRejectedFlag: dateRejectedFlag,
        markedForDelete: false,
      },
    };

    axios
      .post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updatePODetailsNew`,
        data
      )
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: DESTROY_BACKDROP,
          });
          setSuccessDialogBox({
            openDialogBox: true,
            dialogBoxType: type,
          });
        } else {
          setSaveFailed(true);
          dispatch({
            type: DESTROY_BACKDROP,
          });
        }
      })
      .catch((err) => {
        setSaveFailed(true);
        dispatch({
          type: DESTROY_BACKDROP,
        });
        // console.log(err);
      });
    // console.log("data", data);

    // setTimeout(() => {
    //   dispatch({
    //     type: DESTROY_BACKDROP,
    //   });
    //   setSuccessDialogBox({
    //     openDialogBox: true,
    //     dialogBoxType: type,
    //   });
    // }, 3000);
  };
  const getOrganizationIdFromToken = () => {
        const authToken = localStorage.getItem("authToken"); // Get token from localStorage
        if (!authToken) return null; // Return null if no token is found
    
        try {
          const decodedToken = jwtDecode(authToken); // Decode the JWT token
          return decodedToken.collaborator_type_id || null; // Return collaborator_type_id or null if not found
        } catch (error) {
          console.error("Error decoding JWT token:", error);
          return null;
        }
      };
  const collaboratorTypeID = getOrganizationIdFromToken();

  useEffect(() => {
    if (open) {
      const requestObject = {
        searchField: "all",
        searchValue: "",
        reasonCodeGroupType: "all",
        reasonCodeType: "all",
        status: "all",
        collaboratorTypeID: "all"
      };
      axios
        .post(
          `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchReasonCodesDirect`,
          requestObject
        )
        .then((res) => {
          if (res.data.status) {
            if (
              Array.isArray(res.data?.data?.reasonCodeList) &&
              res.data?.data?.reasonCodeList.length > 0
            ) {
              setReasonCodes(res.data.data.reasonCodeList);
            }
          }
        })
        .catch((err) => {
          // console.log(err);
        });
    }
  }, [open]);

  //console.log("data", data);

  // BCM-791: renders the pencil (CMO edit) + accept/reject (Sponsor) controls for a
  // SINGLE value. Accept/reject presence is gated on that value alone.
  const renderProposedControls = (vType) => {
    const hideControls = row?.scheduleLineDetails?.scheduleLineStatusID === 30;
    if (hideControls) return null;
    const hasValue =
      vType === "qty"
        ? row?.scheduleLineDetails?.cmoProposedQuantity != null
        : !!row?.scheduleLineDetails?.cmoProposedDeliveryDate;
    return (
      <Box style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
        {localStorage.collabType === "CMO" &&
          featuresAccess?.editCmoProposedValues && (
            <span title="Edit">
              <EditIcon
                fontSize="large"
                style={{ color: "#ec6535", cursor: "pointer" }}
                onClick={() => handleEditOpen(vType)}
              />
            </span>
          )}
        {localStorage.collabType !== "CMO" &&
          featuresAccess?.acceptOffer === true &&
          hasValue && (
            <span
              title="Accept"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "5px",
              }}
            >
              <CheckCircleIcon
                fontSize="medium"
                style={{
                  backgroundColor: "white",
                  color: "green",
                  fontWeight: "bold",
                  borderRadius: "50%",
                  cursor: "pointer",
                }}
                onClick={() => handleAccept(vType)}
              />
              {featuresAccess?.rejectOffer === true && (
                <span title="Reject">
                  <CancelIcon
                    onClick={() => handleOpen(vType)}
                    className={classes.responseBtn}
                    style={{
                      color: "red",
                      fontSize: "25px",
                      cursor: "pointer",
                    }}
                  />
                </span>
              )}
            </span>
          )}
      </Box>
    );
  };

  return (
    <React.Fragment>
      <TableCell align="right" style={{ whiteSpace: "nowrap" }}>
        <Box
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            justifyContent: "flex-end",
          }}
        >
          {row?.scheduleLineDetails?.cmoProposedQuantity != null
            ? row?.scheduleLineDetails?.cmoProposedQuantity
            : ""}
          {renderProposedControls("qty")}
        </Box>
      </TableCell>

      <TableCell style={{ whiteSpace: "nowrap" }}>
        <Box
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            justifyContent: "flex-start",
          }}
        >
          {dateFormated(
            row?.scheduleLineDetails?.cmoProposedDeliveryDate,
            "DD-MMM-YYYY",
            ""
          )}
          {renderProposedControls("date")}
        </Box>
      </TableCell>

      <Dialog open={open} maxWidth="md" fullWidth>
        <BackDropLoading />
        <DialogContent>
          <Grid container justifyContent="flex-end">
            <Typography
              variant="body2"
              style={{
                fontSize: "1rem",
                fontWeight: 500,
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={() => {
                handleClose();
              }}
            >
              Cancel <CloseIcon style={{ color: "#FF0000" }} fontSize="large" />
            </Typography>
          </Grid>
          <Typography
            style={{
              fontWeight: "500",
              color: "black",
              fontSize: "2rem",
              margin: "1rem",
              textAlign: "center",
            }}
          >
            Rejecting CMO Proposed {rejectLabel} for Delivery {rejectLabel}
          </Typography>
          <Grid
            container
            spacing={0}
            style={{
              marginTop: "1rem",
              display: "flex",
              // alignItems: "center",
              // justifyContent: "space-between",
            }}
          >
            {/* BCM-791: qty reject shows BMS/CMO Proposed Qty + UOM (dates removed) */}
            {rejectValueType === "qty" && (
              <Grid item xs={2} style={{ textAlign: "left" }}>
                <Typography variant="subtitle2" style={{ fontWeight: "bold" }}>
                  BMS proposed qty.
                </Typography>
                <Typography>
                  {row?.scheduleLineDetails?.sponsorProposedQuantity || ""}
                </Typography>
              </Grid>
            )}
            {rejectValueType === "qty" && (
              <Grid item xs={2} style={{ textAlign: "left" }}>
                <Typography variant="subtitle2" style={{ fontWeight: "bold" }}>
                  CMO proposed qty.
                </Typography>
                <Typography>
                  {row?.scheduleLineDetails?.cmoProposedQuantity || ""}
                </Typography>
              </Grid>
            )}
            {rejectValueType === "qty" && (
              <Grid item xs={2} style={{ textAlign: "left" }}>
                <Typography variant="subtitle2" style={{ fontWeight: "bold" }}>
                  UoM
                </Typography>
                <Typography>
                  {row?.scheduleLineDetails?.targetQuantityUOM || ""}
                </Typography>
              </Grid>
            )}

            {/* BCM-791: date reject shows BMS/CMO Proposed Date (qty + UOM removed) */}
            {rejectValueType === "date" && (
              <Grid item xs={2} style={{ textAlign: "left" }}>
                <Typography variant="subtitle2" style={{ fontWeight: "bold" }}>
                  BMS proposed date
                </Typography>
                <Typography>
                  {dateFormated(
                    row?.scheduleLineDetails?.sponsorProposedDeliveryDate,
                    "DD-MMM-YYYY",
                    ""
                  )}
                </Typography>
              </Grid>
            )}
            {rejectValueType === "date" && (
              <Grid item xs={2} style={{ textAlign: "left" }}>
                <Typography variant="subtitle2" style={{ fontWeight: "bold" }}>
                  CMO proposed date
                </Typography>
                <Typography>
                  {dateFormated(
                    row?.scheduleLineDetails?.cmoProposedDeliveryDate,
                    "DD-MMM-YYYY",
                    ""
                  )}
                </Typography>
              </Grid>
            )}
          </Grid>

          <Typography
            variant="subtitle2"
            style={{
              fontWeight: "bold",
              marginTop: "1rem",
              textAlign: "left",
            }}
          >
            Note -
          </Typography>
          <Typography style={{ textAlign: "left" }}>
            {/* BCM-791: note scoped to the value being rejected (PPT slides 7 / 9) */}
            {rejectValueType === "qty"
              ? "The current qty for the PO will be updated after rejection, but the SAP PO Qty value will remain the same."
              : "The current date and SAP Delivery Date for the PO will be updated after rejection, but the SAP Stat Date value will remain the same."}
          </Typography>

          <Grid container spacing={3} style={{ marginTop: "1rem" }}>
            <Grid item xs={4}>
              <Typography variant="subtitle2" style={{ marginBottom: "10px" }}>
                Reason code / Description{" "}
                {/* <span style={{ color: "red" }}>*</span> */}
              </Typography>
              <TextField
                select
                fullWidth
                value={selectedReason}
                onChange={(e) => {
                  setError(false);
                  setSelectedReason(e.target.value);
                }}
                variant="outlined"
                size="small"
                displayEmpty
                error={error && !selectedReason}
                helperText={
                  error && !selectedReason ? "Select reason code" : ""
                }
                style={{ width: "600px" }}
              >
                <MenuItem value="none" disabled>
                  Select Reason Code / Description
                </MenuItem>
                {reasonCodes.map((reason) => (
                  <MenuItem key={reason.reasonCodeID} value={reason.reasonCode}>
                    {reason.reasonCode} / {reason.reasonDescription || ""}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            {/* <Grid item xs={8}>
            <Typography variant="subtitle2" style={{ marginBottom: "10px" }}>
              Reason code description
            </Typography>
            <Typography>
              {reasonCodes.find((r) => r.reasonCode === selectedReason)
                ?.reasonDescription || "-"}
            </Typography>
          </Grid> */}
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="subtitle2" style={{ marginBottom: "10px" }}>
                Comment
              </Typography>
              <TextField
                fullWidth
                multiline
                rows={3}
                value={comment}
                onChange={(e) => {
                  setError(false);
                  if(e.target.value.length < 256){
                  setComment(e.target.value);
                  }
                }}
                variant="outlined"
                size="small"
                error={error}
                placeholder="Enter text here"
                // helperText={error ? "Comment is mandatory if reason code is not selected." : ""}
              />
              <Typography variant="caption" style={{ color: error ? "red" : undefined }}>
                {error
                  ? "Please select a reason code or enter a comment."
                  : "Note - If reason code is not entered, comment field is mandatory."}
              </Typography>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions style={{ padding: 16, justifyContent: "center" }}>
          <Button
            variant="contained"
            color="primary"
            endIcon={<ChevronRight />}
            style={{
              borderRadius: "20px",
              textTransform: "none",
            }}
            onClick={() => {
              const reasonMissing = !selectedReason || selectedReason === "none";
              const commentMissing = !comment.trim();
              const invalid =
                (reasonMissing && commentMissing) ||
                (selectedReason === "EXMRP019" && commentMissing);
              if (invalid) {
                setError(true);
                return;
              }
              const v = rejectValueType;
              handleClose();
              if (row?.scheduleLineDetails?.scheduleLineStatusID == 29) {
                handleSave("revisedOfferRejected", v);
              } else {
                handleSave("RejectOffer", v);
              }
            }}
          >
            {localStorage.collabType !== "CMO" &&
            row?.scheduleLineStatusID === 21
              ? "Save changes and share with CMO"
              : "Save changes"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={successDialogBox.openDialogBox}
        disableBackdropClick // Disable closing on outside click
        disableEscapeKeyDown // Disable closing on escape key
        maxWidth="sm"
        fullWidth
        classes={{ paper: classes.dialogPaper }}
      >
        <DialogContent className={classes.dialogContent}>
          <CheckCircleIcon
            // fontSize="large"
            // style={{backgroundColor:"green",color:"white",fontWeight:"bold"}}
            className={classes.avatar}
          />
          <Typography
            style={{
              marginTop: "10px",
              fontWeight: "600",
              color: "black",
              fontSize: "1.4rem",
            }}
          >
            {/* BCM-791: value-specific accept wording (Sponsor accepting a single CMO value).
                Reject retains the generic "Updated successfully" per PPT slides 7 / 9. */}
            {(successDialogBox.dialogBoxType === "AcceptOffer" ||
              successDialogBox.dialogBoxType === "revisedOfferAccepted") &&
            localStorage.collabType !== "CMO"
              ? `CMO Proposed ${actionLabel} accepted`
              : successDialogBox.dialogBoxType === "valueProposed"
              ? "Updated successfully"
              : "Updated successfully"}
          </Typography>
          <DialogActions className={classes.dialogActions}>
            <Button
              variant="contained"
              color="primary"
              endIcon={<ChevronRight />}
              style={{
                borderRadius: "20px",
                textTransform: "none",
              }}
              onClick={() => {
                // PO dashboard API refreshes "Current Values"; SL details fetch
                // refreshes this row's expanded (chevron) view. Both are needed.
                handleRefresh();
                const schrockenSLID = row?.scheduleLineDetails?.schrockenSLID;
                if (schrockenSLID) {
                  dispatch(fetchSLFromPODashboard(schrockenSLID)).catch(() => {});
                }
                setSuccessDialogBox({
                  openDialogBox: false,
                  dialogBoxType: "",
                });
              }}
            >
              Ok
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>

      <Dialog
        open={saveFailed}
        onClose={() => {
          setSaveFailed(false);
        }}
        fullWidth
      >
        <DialogContent style={{ padding: "2rem" }}>
          <Grid container justifyContent="flex-end">
            <Typography
              variant="body2"
              style={{
                fontSize: "1rem",
                fontWeight: 500,
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={() => {
                setSaveFailed(false);
              }}
            >
              Close <CloseIcon fontSize="large" />
            </Typography>
            <Grid
              item
              xs={12}
              style={{ display: "flex", justifyContent: "center" }}
            >
              <WarningIcon
                style={{
                  fontSize: "5rem",
                  color: "#F00",
                }}
              />
            </Grid>
          </Grid>
          <div
            style={{
              display: "flex",
              justifyContent: "center", // Horizontally center the CircularProgress
              alignItems: "center", // Vertically center the CircularProgress
              height: "80px", // Optional: Set a height to vertically center the loader
              border: "2px solid #FF0000",
              backgroundColor: "#FFF0F0",
              // width: "100%",
            }}
          >
            <Typography style={{ textAlign: "center" }}>
              Something went wrong. Please try again.
            </Typography>
          </div>

          <Grid
            item
            xs={12}
            style={{
              display: "flex",
              justifyContent: "center",
              textAlign: "center",
              padding: "0.5rem",
            }}
          >
            <StyledButton
              style={{ paddingLeft: "3rem", paddingRight: "3rem" }}
              onClick={() => {
                setSaveFailed(false);
              }}
            >
              Ok
            </StyledButton>
          </Grid>
        </DialogContent>
      </Dialog>

      {negotiation && (
        <PONegotiationDialogBox
          open={negotiation}
          handleClose={handleNegotiation}
          row={row}
          valueType={negotiationValueType}
        />
      )}
    </React.Fragment>
  );
};

export default EditCDMOPOColumns;
